/** Joins PUBLIC_URL with a public-folder path (handles optional subpath deploys). */
export function publicAssetUrl(path: string): string {
  const base = (process.env.PUBLIC_URL ?? '').replace(/\/$/, '');
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalized}`;
}

/** Public URL to the official Sustainow Carbon Intelligence logo (PNG). */
export const BRAND_LOGO_SRC = publicAssetUrl('/sustainow-ci-logo.png');
/** Logo used in pre-login dashboard and information page body areas. */
export const BRAND_BODY_LOGO_SRC = publicAssetUrl('/sustainow-ci-logo_2.png');
/**
 * Pre-login landing hero mark (dark): Sustainow Carbon Intelligence brand lockup
 * with symbolic industry, carbon footprint, compliance, and reporting motifs.
 */
export const BRAND_PRELOGIN_SCENE_SRC = publicAssetUrl('/sustainow-ci-prelogin-brand-scene.png');
/** Light-background variant of {@link BRAND_PRELOGIN_SCENE_SRC} for light theme. */
export const BRAND_PRELOGIN_SCENE_LIGHT_SRC = publicAssetUrl(
  '/sustainow-ci-prelogin-brand-scene-light.png'
);

/** Resolve pre-login brand scene for the active color mode. */
export function brandPreloginSceneSrc(mode: 'light' | 'dark' = 'light'): string {
  return mode === 'dark' ? BRAND_PRELOGIN_SCENE_SRC : BRAND_PRELOGIN_SCENE_LIGHT_SRC;
}
/** Dashboard nav mark — lotus symbol cropped from the official logo (public/symbol.png). */
export const BRAND_DASHBOARD_MARK_SRC = publicAssetUrl('/symbol.png');
/** Browser tab / PWA icon — same mark as the compact header lockup. */
export const BRAND_FAVICON_SRC = BRAND_DASHBOARD_MARK_SRC;
/** Raster fallback when a second favicon link is needed (same asset as compact header). */
export const BRAND_FAVICON_FALLBACK_SRC = BRAND_DASHBOARD_MARK_SRC;

/** First line of the product name (matches launch logo typography). */
export const BRAND_NAME_LINE_1 = 'sustainow';
/** Second line of the product name (matches launch logo typography). */
export const BRAND_NAME_LINE_2 = 'Carbon Intelligence';
/** Product tagline shown under the application name in the header. */
export const BRAND_TAGLINE = 'Measure · Report · Reduce';
/** Highlight label for the patent-pending platform. */
export const BRAND_PATENT_PENDING_LABEL = 'Patent pending';
/** Longer patent notice for hero/marketing surfaces. */
export const BRAND_PATENT_PENDING_BANNER =
  'Patent pending — Sustainow Carbon Intelligence workflow for MSME measurement, AI analytics, and disclosure-ready reporting.';
